// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"FormTextarea_formLabel__qWVpZ","labelText":"FormTextarea_labelText__QaDnW","textAreaEl":"FormTextarea_textAreaEl___p_CH"};